import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormlyModule } from '@ngx-formly/core';

import { UiModule } from '@lockton-apps/shared/ui/lui';

import { MatFormFieldWrapperComponent } from './mat-form-field-wrapper.component';
import { CastObservablePipe } from '@lockton-apps/shared/ui/pipes';

@NgModule({
  declarations: [MatFormFieldWrapperComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    UiModule,
    FormlyModule.forChild({
      wrappers: [
        {
          name: 'mat-form-field',
          component: MatFormFieldWrapperComponent,
        },
      ],
    }),
    CastObservablePipe,
  ],
})
export class MatFormFieldWrapperModule {}
